
import { http } from "@/api/index";

/**
* @summary Obtem itens da toolbar.
* @param {Number - String} companyId - Id da empresa.
* @returns {Array - Json} Retorna um array da treeview.
*/
const GetToolBarMenu = function(companyId)
{
	return http.get(`/TreeMenu/${companyId}`);
};

/**
* @summary Obtem itens da toolbar do administrador Global.
* @param {Number - String} companyId - Id da empresa.
* @returns {Array - Json} Retorna um array da treeview.
*/
const GetGlobalAdministratorMenu = function()
{
	return http.get("/TreeMenu");
};

const GetToolBarMonitoringElement = function(monitoringElementId = 0)
{
	return http.get(`/Toolbar/${monitoringElementId}`);
};

export default {
	GetToolBarMenu,
	GetGlobalAdministratorMenu,
	GetToolBarMonitoringElement
};
